/**
 * @generated SignedSource<<b5864028fc28f31994f483fcbaca39b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PredictPrintAreasInput = {
  confidence?: number | null;
  imageUrl: string;
  includeAnnotatedImage?: boolean | null;
};
export type areaDesignerPredictPrintAreasMutation$variables = {
  input: PredictPrintAreasInput;
};
export type areaDesignerPredictPrintAreasMutation$data = {
  readonly predictPrintAreas: {
    readonly detections: ReadonlyArray<{
      readonly bboxPixels: {
        readonly height: number;
        readonly width: number;
        readonly x: number;
        readonly y: number;
      } | null;
      readonly confidence: number;
    }>;
    readonly error: string | null;
    readonly imageInfo: {
      readonly height: number;
      readonly ppcmAvg: number | null;
      readonly width: number;
    } | null;
    readonly success: boolean;
  };
};
export type areaDesignerPredictPrintAreasMutation = {
  response: areaDesignerPredictPrintAreasMutation$data;
  variables: areaDesignerPredictPrintAreasMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PredictPrintAreasOutput",
    "kind": "LinkedField",
    "name": "predictPrintAreas",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PredictedPrintAreaImageInfo",
        "kind": "LinkedField",
        "name": "imageInfo",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ppcmAvg",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PredictedPrintAreaDetection",
        "kind": "LinkedField",
        "name": "detections",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confidence",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PredictedBoundingBox",
            "kind": "LinkedField",
            "name": "bboxPixels",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "x",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "y",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "areaDesignerPredictPrintAreasMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "areaDesignerPredictPrintAreasMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "cc776c48616f2babb83d332becb6f015",
    "id": null,
    "metadata": {},
    "name": "areaDesignerPredictPrintAreasMutation",
    "operationKind": "mutation",
    "text": "mutation areaDesignerPredictPrintAreasMutation(\n  $input: PredictPrintAreasInput!\n) {\n  predictPrintAreas(input: $input) {\n    success\n    error\n    imageInfo {\n      width\n      height\n      ppcmAvg\n    }\n    detections {\n      confidence\n      bboxPixels {\n        x\n        y\n        width\n        height\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3038c6cf79d5de21131812d9955ee228";

export default node;
